import React, { FC } from "react";
import type { ClearingInstitutionsHighRiskClassificationProps } from "@/types";
import { TextCols } from "../text-cols";

export const ClearingInstitutionsHighRiskClassification: FC<
  ClearingInstitutionsHighRiskClassificationProps
> = ({ content }) => {
  return (
    <section className="clearingInstitutionsHighRiskClassification">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={766} />
      </div>
    </section>
  );
};
